import { render, staticRenderFns } from "./FileInputDragDrop.vue?vue&type=template&id=52245af4&"
import script from "./FileInputDragDrop.vue?vue&type=script&lang=js&"
export * from "./FileInputDragDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports